var map = {
	"./Accessories.jpg": "d0e6",
	"./Cart.jpg": "6c50",
	"./Claim Orders.jpg": "0f00",
	"./Creat claim.jpg": "9b12",
	"./Create claim.jpg": "b8ab",
	"./Invoice.jpg": "918f",
	"./Orders.jpg": "d82c",
	"./Parts.jpg": "6eda",
	"./Vehicle registration.jpg": "4a0d",
	"./loginbing.jpg": "4345",
	"./mrimg2.jpg": "038c",
	"./qm.jpg": "670d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";